//@ts-nocheck
import importCompont from '@pn/components/src/utils/importCompont'
import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import useAppContext from '@/useAppContext'
import { motion } from 'framer-motion'
import { checkZFyewuPermission } from '@/utils/permissionCheck'

const GRyewu = importCompont(() => import('./Shuloubao/GRyewu/Home/home'))
const CreateDingdan = importCompont(() => import('./Shuloubao/GRyewu/CreateDingdan'))
const DingdanXq = importCompont(() => import('./Shuloubao/GRyewu/DingdanXq'))
const ProcessXq = importCompont(() => import('./Shuloubao/GRyewu/Process/result'))
const ZFyewu = importCompont(() => import('./Shuloubao/ZFyewu/Home/home'))
const ZFdaizhifu = importCompont(() => import('./Shuloubao/ZFyewu/Daizhifu'))
const ZFdaizhifuPlay = importCompont(() => import('./Shuloubao/ZFyewu/Daizhifu/Play'))

const Page404 = () => {
  const { context } = useAppContext.getContext()
  const { loading } = context
  if (loading) {
    return <div />
  }
  return <Navigate replace to={{ pathname: '/' }} />
}

const AnimatedDiv = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  return (
    <motion.div
      key={location.pathname}
      initial={{ opacity: 0, }}
      animate={{ opacity: 1, }}
      exit={{ opacity: 0, }}
      style={{ height: '100%' }}
      transition={{
        duration: 0.3,
        ease: [0.4, 0, 0.2, 1],
      }}>
      {children}
    </motion.div>
  );
};



const ProtectedZFyewu = () => {
  const hasPermission = checkZFyewuPermission()

  if (!hasPermission) {
    return <Navigate to="/" replace />
  }

  return (
    <AnimatedDiv>
      <ZFyewu />
    </AnimatedDiv>
  )
}

export const routes = [
  {
    path: '/*',
    name: '首页',
    element: (
      <AnimatedDiv>
        <Navigate to="/GRyewu" replace />
      </AnimatedDiv>
    ),
  },

  {
    path: '/GRyewu/*',
    name: '个人业务',
    element: (
      <AnimatedDiv>
        <GRyewu />
      </AnimatedDiv>
    ),
  },

  {
    path: '/GRyewu/Dingdan/detail/:id',
    name: '订单详情',
    element: (
      <AnimatedDiv>
        <DingdanXq />
      </AnimatedDiv>
    ),
  },
  {
    path: '/GRyewu/Dingdan/process/:id',
    name: '审核详情',
    element: (
      <AnimatedDiv>
        <ProcessXq />
      </AnimatedDiv>
    ),
  },
  {
    path: '/GRyewu/CreateDingdan',
    name: '创建订单',
    element: (
      <AnimatedDiv>
        <CreateDingdan />
      </AnimatedDiv>
    ),
  },
  {
    path: '/ZFyewu/*',
    name: '支付业务',
    element: <ProtectedZFyewu />,
  },
  {
    path: `/ZFyewu/ZFdaizhifu/:id/:zfId`,
    name: '待支付',
    element: (
      <AnimatedDiv>
        <ZFdaizhifu />
      </AnimatedDiv>
    ),
  },
  {
    path: `/ZFyewu/ZFdaizhifu/Play/:id/:zfId`,
    name: '支付',
    element: (
      <AnimatedDiv>
        <ZFdaizhifuPlay />
      </AnimatedDiv>
    ),
  },
  { path: '*', element: <AnimatedDiv><Page404 /></AnimatedDiv> },
]